import type {TransportCategory} from "@ots-frontend/ots-data";
import {useMemo, useRef} from "react";
import {createTicketDataGridColumns} from "./ticketDataGridColumns";

export type UseTicketDataGridColsProps = {colWidths?: (number | undefined)[]; category?: TransportCategory};

export function useTicketDataGridCols({colWidths, category}: UseTicketDataGridColsProps) {
  // Seed once per category so legacy resize feedback cannot change the reset target.
  const initialWidths = useRef(new Map<string, (number | undefined)[]>());
  const scope = category?.code === "OIL" ? "oil" : "standard";
  if (!initialWidths.current.has(scope)) initialWidths.current.set(scope, [...(colWidths ?? [])]);
  const seed = initialWidths.current.get(scope);
  const colsMap = useMemo(() => createTicketDataGridColumns(category, seed), [seed, category]);
  return {colsMap};
}
